module.exports = __webpack_public_path__ + "static/media/icon_weixian.b99623a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/icon_weixian.svg
// module id = 566
// module chunks = 0